import React, { useRef } from 'react';

import classNames from 'classnames';
import useIntersection from 'buena-suerte/lib/hooks/useIntersection';

export default ({ image }) => {
  const intersectionRef = useRef();
  const isIntersected = useIntersection(intersectionRef);

  return (
    <section
      ref={intersectionRef}
      className={classNames('page-hero-image x reveal', {
        revealed: isIntersected,
      })}
    >
      <picture>
        <source
          srcSet={`${image.url}?w=2000&auto=format&q=100`}
          media="(min-width: 1200px)"
        />
        <source
          srcSet={`${image.url}?w=1200&auto=format&q=100`}
          media="(min-width: 1000px)"
        />
        <source
          srcSet={`${image.url}?w=800&auto=format&q=100`}
          media="(min-width: 600px)"
        />
        <img
          alt={image.alt}
          className="db"
          src={`${image.url}?w=600&auto=format&q=100`}
        />
      </picture>
    </section>
  );
};
